export const subtitles = {
    "1": {
        "startTime": 47.87,
        "endTime": 52.07,
        "transcript": "Waqaa, wiinga Hazel Lincoln-aaruunga, Yugtun-llu atqa Qang'allugauluni.",
        "translation": "Hello, I'm Hazel Lincoln, and my Yup'ik name is Qang'allugaq."
    },
    "2": {
        "startTime": 52.075,
        "endTime": 55.285,
        "transcript": "Quyana ilagarluta Delta Review-aaqatallemteńi.",
        "translation": "Thank you for joining us on our Delta Review."
    },
    "3": {
        "startTime": 55.285,
        "endTime": 59.715,
        "transcript": "Atakurpak Kuigglugmiut tegganrat Jimmy Chimigalrea-m ilagarciqaakut.",
        "translation": "This eveneing, an elder for Kwethluk, Jimmy Chimigalrea, will join us."
    },
    "4": {
        "startTime": 59.715,
        "endTime": 66.825,
        "transcript": "Cali maniqatartukut aipaat ukut yurallrat Mountain VIllage-ami yurarpallratni uumi Agayunermi kitullermi.",
        "translation": "We will also be showing the others who Yup'ik danced in Mountain Village for the dance festival this past Sunday."
    },
    "5": {
        "startTime": 66.825,
        "endTime": 70.22,
        "transcript": "Ciumek niicugninauraput Chimigalrea qalartellra.",
        "translation": "First, let's listen to what Chimigalrea has to say."
    },
    "6": {
        "startTime": 70.22,
        "endTime": 74.04,
        "transcript": "Yugtun taringtukuvci niicugninqegcaarniartuci.",
        "translation": "If you understand Yup'ik, listen closely."
    },
    "7": {
        "startTime": 75.085,
        "endTime": 82.405,
        "transcript": "Tua-i yugni tamaitni niitellriani wangkutni, elpeceńi tua-i yugni tamaitni",
        "translation": "To all people, we who are listening, all of you people"
    },
    "8": {
        "startTime": 82.53,
        "endTime": 89.63,
        "transcript": "Waten tuaten ayuqesqessaaqut, iliit waniwa tua-i niitnaqsaaqelria.",
        "translation": "They are asked to be like this, we need to hear one of them."
    },
    "9": {
        "startTime": 89.635,
        "endTime": 95.645,
        "transcript": "Waten qanerluni Philippianes tayima 2:12",
        "translation": "It says in Philippians 2:12"
    },
    "10": {
        "startTime": 95.645,
        "endTime": 104.135,
        "transcript": "Waten qanerluni: \"Taum kenkekma maligtaqutelaucirpecetun ilakellerpeceńi watua",
        "translation": "It says this: \"As you obey the one whom I love as you are together now"
    },
    "11": {
        "startTime": 104.135,
        "endTime": 112.13,
        "transcript": "\"Ilaknrilngerpecia anirtuumallerkarci caliaqiciu qigcigyugluci alinguryugluci-llu.",
        "translation": "\"Even though I am not your relative, work on your salvation out of respect and fear."
    },
    "12": {
        "startTime": 112.13,
        "endTime": 120.66,
        "transcript": "\"Tua-i Agayutnguan elpeceńi calilria. Piyuumircetaqluci aturcetaqluki-llu elliin pisqutni.",
        "translation": "\"For it is God who works in you. He gives you fervor and has you follow his will."
    },
    "13": {
        "startTime": 120.66,
        "endTime": 123.25,
        "transcript": "\"Caliluci tamaitgun.",
        "translation": "\"Work through all of them."
    },
    "14": {
        "startTime": 123.25,
        "endTime": 130.52,
        "transcript": "\"Qanemyuugaqsaunaci, qanekluarpek'naci. Qanernarqutaunaci.",
        "translation": "\"Do not grumblr, and do not say unfavorable things. Do not make yourself need admonishment."
    },
    "15": {
        "startTime": 130.52,
        "endTime": 134.4,
        "transcript": "\"Paqnanarqevkenaci Agayutem yuknauraaci.",
        "translation": "\"So that you will be God's people without drawing attention."
    },
    "16": {
        "startTime": 134.405,
        "endTime": 139.315,
        "transcript": "\"Apquciinaci piciunrilnguut assiilnguut-llu akuliitni.",
        "translation": "\"You shall have no ailments among the false and the sinful."
    },
    "17": {
        "startTime": 139.315,
        "endTime": 143.55,
        "transcript": "\"Akuliitni-llu tanqignaurtuci agyatun ellam iluani.\"",
        "translation": "\"And so that you shall shine like stars among them in the world.\""
    },
    "18": {
        "startTime": 143.55,
        "endTime": 149.6,
        "transcript": "Tua-i-w' unguvam qaneryaraa maniluku. Tua-i wavet ciuqliliqe'rqa au͡g'umek.",
        "translation": "It showed the wisdom concerning life. I started off with that."
    },
    "19": {
        "startTime": 149.6,
        "endTime": 155.87,
        "transcript": "Yugni tamamta au͡gna ava-i niitnariyaaqerput, pinrilngurmek ilaunata.",
        "translation": "It's time we people hear that, without leaving anyone out."
    },
    "20": {
        "startTime": 156.39,
        "endTime": 162.03,
        "transcript": "Iciw' tua-i caaciteqsuunata, iqluyuirulluta.",
        "translation": "You know, we shouldn't [?], and stop lying."
    },
    "21": {
        "startTime": 162.035,
        "endTime": 170.45,
        "transcript": "Cali-llu ilamteńun maavet ilaput makut umyuarrliqutnanrirluki, umyuangcayuunata-llu yuut nallukiitgun assiitellriamek.",
        "translation": "Also, we must stop thinking malicious things about those around us, and do not think bad things about people in secret."
    },
    "22": {
        "startTime": 170.45,
        "endTime": 172.06,
        "transcript": "Tua-i waten pitaluku.",
        "translation": "That's all for that."
    },
    "23": {
        "startTime": 173.32,
        "endTime": 177.83,
        "transcript": "Wangkutnun man'a tua-i niitnariyaaquq.",
        "translation": "It's time that we hear this."
    },
    "24": {
        "startTime": 177.83,
        "endTime": 185.23,
        "transcript": "Tua-ll' man'a maa-i ak'anek ayaglua allrakuni au͡gkuni pellullerni",
        "translation": "Then this, started from a long time ago in those years that have passed"
    },
    "25": {
        "startTime": 185.235,
        "endTime": 192.15,
        "transcript": "Yuut ilaita pilaryaaqaatnga man'a qanrutkeqaasqelluku uuggun KYUK-kun",
        "translation": "Some people tell me that I should talk about this here on KYUK"
    },
    "26": {
        "startTime": 192.15,
        "endTime": 199.86,
        "transcript": "Waten erinama sagtenrullerkaa tua-i tamana piyaaqluku.",
        "translation": "So that my voice would spread out more like this."
    },
    "27": {
        "startTime": 199.86,
        "endTime": 206.3,
        "transcript": "Qagkut-ll' ilaita yaaqvaarmiut Kuigpagmiut-llu pilaryaaqaatnga ak'anek ayaglua allrakuni.",
        "translation": "Some people up there, far away from the Yukon, have also been telling me for many years."
    },
    "28": {
        "startTime": 206.305,
        "endTime": 214.26,
        "transcript": "Tau͡gaam ukut KYUK-rmiut wiinga tua-i capeqluki ullayuitanka uum ciungani.",
        "translation": "But since I found it daunting to go to KYUK, I wouldn't go to them before this."
    },
    "29": {
        "startTime": 214.26,
        "endTime": 225.26,
        "transcript": "Cali-llu yualaryaaqellruunga mat'um-wa tua-i qanrutkarkama wangni pinruluku qanrutkestekaanek.",
        "translation": "Also, I used to look for someone to who could speak about this better than I could."
    },
    "30": {
        "startTime": 225.265,
        "endTime": 227.8,
        "transcript": "Tau͡gaam ilaita-llam pilaraatnga",
        "translation": "However, some of them would say to me"
    },
    "31": {
        "startTime": 227.8,
        "endTime": 238.29,
        "transcript": "Aren allamek-gguq wangni qanrutkeluaqanrustekaituq. Wiinga-gguq qanruteklaku tau͡gaam.",
        "translation": "Oh my, they said that there is no one who can say it better than me. They said that I should speak about it instead."
    },
    "32": {
        "startTime": 238.29,
        "endTime": 243.34,
        "transcript": "Tua-i waniwa cayaqlirluku qanqautekqata'arqa.",
        "translation": "Now, I am finally going to speak about it."
    },
    "33": {
        "startTime": 244.17,
        "endTime": 254.64,
        "transcript": "Atam wiinga tua-i avani ella iqukluku qantullratni, anguanka au͡gkut ella iqukluku qantulriit.",
        "translation": "You see, when they used to speak about the end of the world, I was born in time to see the ones who spoke about the end of the world."
    },
    "34": {
        "startTime": 255.49,
        "endTime": 263.89,
        "transcript": "Tamana-wa tua-i ak'a yaaqvani piitnaq qanrutketullrat qanrutkelartai angullruanka tua-i.",
        "translation": "Well, I was born in time to see the ones who spoke about the time of famine far in the future."
    },
    "35": {
        "startTime": 264.115,
        "endTime": 275.41,
        "transcript": "Tua-ll' tang ataucim tang au͡g'um qanellra tua-i tang waniwa umyuaqelgurikeka tang tua-i.",
        "translation": "Then, you see, what that one person said always comes to mind now."
    },
    "36": {
        "startTime": 275.41,
        "endTime": 284.08,
        "transcript": "Tua-i-ll' umyuaqelguriamku ella tang tua-i una aaryaruskeka iqukvanerrlugqurainarnayukluku.",
        "translation": "Then since it always come to my mind, I've become wary of this world, thinking that it would end badly."
    },
    "37": {
        "startTime": 284.18,
        "endTime": 291.7,
        "transcript": "Kiima-llu pinritliniluku. Tua-i ilaita aaryagutaat una ella.",
        "translation": "And I'm not the only one. Some others have become wary of this world."
    },
    "38": {
        "startTime": 293.075,
        "endTime": 305.25,
        "transcript": "Tua-i tamaani atam maaten murilkessagutua angukara'urluut arnassagaat ilait waten ciisqugni ayaperlukek piyuayaurrluteng",
        "translation": "Back then, you see, I realized when I became observant that some old men and women would walk, supporting themselves on their knees like this"
    },
    "39": {
        "startTime": 305.25,
        "endTime": 308.1,
        "transcript": "Ilait tau͡gken piyuananrirluteng",
        "translation": "Yet some couldn't walk anymore"
    },
    "40": {
        "startTime": 308.29,
        "endTime": 312.41,
        "transcript": "Arnassagangqetullratni angukara'urlungqerrluteng-llu.",
        "translation": "When they had old women and men."
    },
    "41": {
        "startTime": 313.085,
        "endTime": 319.695,
        "transcript": "Ilait tegularluki qasgimek anulluki maqilallruut",
        "translation": "They would carry some out of the community house to take sweat baths"
    },
    "42": {
        "startTime": 319.695,
        "endTime": 324.705,
        "transcript": "Taqngameng-llu cali itrulluki piyuananrilriit tamakut.",
        "translation": "And when they were done, they brought in the ones who couldn't walk anymore."
    },
    "43": {
        "startTime": 325.7,
        "endTime": 332.63,
        "transcript": "Tua-ll' ella iqukluku qanllermeggni waten ilait qanellruut:",
        "translation": "Then when they spoke about the end of the world, some of them said this:"
    },
    "44": {
        "startTime": 332.63,
        "endTime": 340.1,
        "transcript": "Tamaa-i-gguq tamakut ak'allaunqurrit tamatum tua-i ellam aciani",
        "translation": "They said that those who are the oldest there under the earth"
    },
    "45": {
        "startTime": 340.1,
        "endTime": 346.52,
        "transcript": "Tamatum niitetullemta aciani yuullret tamakut ak'allaunqurrit",
        "translation": "Those who lived, the oldest ones, under the one we used to hear about"
    },
    "46": {
        "startTime": 346.525,
        "endTime": 354.16,
        "transcript": "Qanertut, \"Yuk-gguq yuunertuqeryaaqaquq. Tamana-gguq aipiringaitaa.\"",
        "translation": "They said, \"A person lives for quite a long time. (S)he will not live another [life].\""
    },
    "47": {
        "startTime": 354.16,
        "endTime": 357.83,
        "transcript": "Tua-i cali waten qanertut:",
        "translation": "They also said this:"
    },
    "48": {
        "startTime": 357.83,
        "endTime": 366.56,
        "transcript": "Atam-gguq tamaani... ella iqukluku qantullratni tamaani ciuqvani",
        "translation": "You see, they said, a long time ago... when they used to speak about the end of the world a long time ago"
    },
    "49": {
        "startTime": 366.56,
        "endTime": 370.66,
        "transcript": "Atam-gguq ilait makut nukalpiat",
        "translation": "You see, they said, some of these great hunters"
    },
    "50": {
        "startTime": 371.725,
        "endTime": 380.255,
        "transcript": "Waten qasgimi taklangyullerminek-llu qanelria tauna angukara'urluq un'gani caniqami qanelria niilluku",
        "translation": "After this old man was laying in the community house, he said listening to the one by the wall near the door say"
    },
    "51": {
        "startTime": 380.255,
        "endTime": 388.445,
        "transcript": "Ilii-gguq tang maktaqellria, \"A, amci-gguq-qaa piyuan tungenqegturanemteńi.\"",
        "translation": "They said that one of them got up, \"Ah, it should happen already while we are [doing well].\""
    },
    "52": {
        "startTime": 388.445,
        "endTime": 392.475,
        "transcript": "Cunawa-gguq tamaa-i tamatum pistekameng mallgillrani.",
        "translation": "They said that it was apparently when the one who would [?take] them was getting close."
    },
    "53": {
        "startTime": 392.475,
        "endTime": 401.93,
        "transcript": "Yuut-gguq iciw' ilacingllermeggni-gguq cunawa ilaciqanricuitut-gguq yuut",
        "translation": "They said that when people, you know, apparently waited for others to act, you know people sometimes wait for others to act"
    },
    "54": {
        "startTime": 401.93,
        "endTime": 410.45,
        "transcript": "Anucimirqecetaarumallerkameng-wa tua-i tamatum piciqiangaqateng mallgikateng.",
        "translation": "When they ask to be set free when what they're about to do is approaching."
    },
    "55": {
        "startTime": 410.455,
        "endTime": 415.165,
        "transcript": "Tua-ll' tamaani, tamaa-i tamatum nalliini",
        "translation": "Then at that time, at that time"
    },
    "56": {
        "startTime": 415.735,
        "endTime": 423.335,
        "transcript": "Wiinga-ll' tua-i tamakut erenret tanglallruanka. Tuar tang uksumi ataucimi pillrulriit.",
        "translation": "I also used to see those days. I think those happened over one winter."
    },
    "57": {
        "startTime": 423.47,
        "endTime": 434.79,
        "transcript": "Ernertangyaurtellruuq waten erenrillermi kinguani qavaggun ernertangyarani kiatruarrluku negrem tua-i tungiikun.",
        "translation": "Day started breaking after dawn like this further upriver, past where the day breaks toward the north."
    },
    "58": {
        "startTime": 434.795,
        "endTime": 437.905,
        "transcript": "Ernekegtaar unuurrluni.",
        "translation": "The wonderful day became night."
    },
    "59": {
        "startTime": 437.905,
        "endTime": 446.275,
        "transcript": "Tua-i qanlartut ilait tamakut angutet erneruaryaurrniluku, camek iquliqsaunaku.",
        "translation": "Some of those men say that the day has become false, without any further explanation."
    },
    "60": {
        "startTime": 446.275,
        "endTime": 454.805,
        "transcript": "Tua-llam cat iliitni akusrarrluta tua-i laanguarluta tua-i tan'geriluni tua-i.",
        "translation": "Then one day, we were playing excitedly, and it got dark."
    },
    "61": {
        "startTime": 455.095,
        "endTime": 462.625,
        "transcript": "Enemun, enemun tua-i anglicartekellregma enekenrilkiignun iterlua.",
        "translation": "I went into a house that was not of those who raised me."
    },
    "62": {
        "startTime": 462.625,
        "endTime": 467.455,
        "transcript": "Tua-i-ll' itqanemkun arnaq au͡gna iterluni kingumkun.",
        "translation": "Then right when I went in, that woman came in after me."
    },
    "63": {
        "startTime": 467.455,
        "endTime": 473.765,
        "transcript": "Tua-ll' itrami kanani aqumvailegmi qanertuq, \"Tua-i-am keggna ernertanglliniuq.\"",
        "translation": "Then when she came in, she said before she sat down there, \"There is now day out there.\""
    },
    "64": {
        "startTime": 473.765,
        "endTime": 482.02,
        "transcript": "Tua-ll' tauna tamatum enem yuin angukara'urluat angukara'urluq qanertuq",
        "translation": "The the old man of that house said"
    },
    "65": {
        "startTime": 482.02,
        "endTime": 488.7,
        "transcript": "\"When this world is on the brink [of ending], it doesn't leave its people in the dark.",
        "translation": "\"When this world is on the brink [of ending], it doesn't leave its people in the dark."
    },
    "66": {
        "startTime": 488.705,
        "endTime": 492.065,
        "transcript": "\"Tau͡gaam-gguq atam elpegcilirraatui.",
        "translation": "\"But, you see, it gives them notice first."
    },
    "67": {
        "startTime": 492.82,
        "endTime": 499.56,
        "transcript": "\"Atam-gguq tamaa-i elpegcilirai tua-i tamana aturarkani ellangcautekani.",
        "translation": "\"Look, it is giving notice to them about the lesson it's going to teach them."
    },
    "68": {
        "startTime": 499.565,
        "endTime": 506.615,
        "transcript": "\"Pinariata tua-i elliin yun'i tangerrluki, makut nunami yuulriit tangerrluki tua-i pinariata.",
        "translation": "\"It sees its people, sees the people on this earth because it's time for them."
    },
    "69": {
        "startTime": 506.615,
        "endTime": 512.265,
        "transcript": "\"Atam-gguq tamaa-i nasvagaa ellaitnun tua-i tamaa-i tamaaggun piarkaurrluki.\"",
        "translation": "\"Look, it is showing it to them, and will [correct] them through that.\""
    },
    "70": {
        "startTime": 512.265,
        "endTime": 517.895,
        "transcript": "Tua-ll' qanertuq, \"Atam-gguq yuut neryuniuryaaqniartut.",
        "translation": "Then he said, \"People will wait expectantly."
    },
    "71": {
        "startTime": 517.895,
        "endTime": 527.305,
        "transcript": "\"Atam-gguq neryuniuryaaqvimeggnek neryuniunrirniartut, neryuniulriartairulluni-llu.",
        "translation": "\"Watch, as they are eagerly waiting, they will stop waiting eagerly, then there will be no one left who is wating eagerly."
    },
    "72": {
        "startTime": 527.305,
        "endTime": 533.1,
        "transcript": "\"Atam-llu-gguq ella iqukluku qanelriamek niitnanrirniartut.\"",
        "translation": "\"And watch, they will stop hearing anyone say the world is ending.\""
    },
    "73": {
        "startTime": 533.1,
        "endTime": 538.68,
        "transcript": "Tua-i maa-i taum qanellra tua-i nall'aringaarput.",
        "translation": "We now coincide with what he said."
    },
    "74": {
        "startTime": 538.68,
        "endTime": 549.77,
        "transcript": "Cali-llu-gguq atam qanikcangqerrnanrirniartuq wagg'uq ata ataucimun ellimangkuniu.",
        "translation": "He also said that there would be no more snow, that is, when [the world] starts putting it into one place."
    },
    "75": {
        "startTime": 549.77,
        "endTime": 553.6,
        "transcript": "Tua-i taum qanellra waniwa tua-i umyuaqelguriaqa.",
        "translation": "Now, what he said always comes to mind."
    },
    "76": {
        "startTime": 553.6,
        "endTime": 560.11,
        "transcript": "Tua-i ella una aaryagutaqa. Wiinga ellam uum catacia nalluyaaqaqa.",
        "translation": "I am not wary of this world. I don't know what this world is doing."
    },
    "77": {
        "startTime": 560.39,
        "endTime": 564.22,
        "transcript": "Tua-ll' cali waten qanellruut:",
        "translation": "Then, they also said this:"
    },
    "78": {
        "startTime": 564.99,
        "endTime": 569.66,
        "transcript": "\"Meluk,\" kiingan tua-i qanrutketullruat.",
        "translation": "\"Fish roe,\" it was the only one they mentioned."
    },
    "79": {
        "startTime": 569.66,
        "endTime": 578.58,
        "transcript": "Meluk-gguq man'a tua-i allrakurtaaryaaqeciquq nunam iluani.Tua-i-gguq cangaringaituq.",
        "translation": "They said that fish roe would be in the land year after year. They said it wouldn't spoil."
    },
    "80": {
        "startTime": 578.585,
        "endTime": 584.835,
        "transcript": "Yuum iluanun alingnaringaituq nunam iluani tua-i allrakurtaange'rmi.",
        "translation": "It will not become dangerous inside a person though it spends year after year in the land."
    },
    "81": {
        "startTime": 584.835,
        "endTime": 587.37,
        "transcript": "Tua-i kiingan qanrutketullruat.",
        "translation": "That was the only one they mentioned."
    },
    "82": {
        "startTime": 587.37,
        "endTime": 592.27,
        "transcript": "Tua-ll' mat'um nalliini makut freezer-aat piyaaqut.",
        "translation": "Then these days, there are now freezers."
    },
    "83": {
        "startTime": 592.275,
        "endTime": 597.185,
        "transcript": "Tau͡gaam malruugut makut, freezer-aaq man'a malruuguq.",
        "translation": "But there are two things, there are two things [that don't spoil] in freezers."
    },
    "84": {
        "startTime": 597.185,
        "endTime": 605.255,
        "transcript": "Tau͡gaam una sulunaq umyuarteqaqama cali allrakurtaaryaaqmiciquq elluarrluni taryiumakuni",
        "translation": "But when I think about this salted fish, it may also spend year after year if it is salted well"
    },
    "85": {
        "startTime": 605.255,
        "endTime": 609.57,
        "transcript": "Allrakut tegulang'ermiki tua-i cangaringailmiuq tauna.",
        "translation": "It may take on years, but that will not spoil either."
    },
    "86": {
        "startTime": 609.57,
        "endTime": 614.6,
        "transcript": "Man'a-ggem tua-i freezer-aaq malruuguq. Catacia nallunartuq.",
        "translation": "There are two things [that don't spoil] in freezers. What it does is irregular."
    },
    "87": {
        "startTime": 614.8,
        "endTime": 624.24,
        "transcript": "Tua-ll' cali mat'um nalliini ukut aipaiput tua-i qagruyaaqut watua maa-i ernermi qak'mumi.",
        "translation": "And these days, our [Caucasian] counterparts are [?] in this current day."
    },
    "88": {
        "startTime": 624.245,
        "endTime": 632.295,
        "transcript": "Tau͡gaam ayainanermeggni-wa nallunartuq umyuarteqaqama.",
        "translation": "But as they go, it's hard to know when I think about it."
    },
    "89": {
        "startTime": 632.295,
        "endTime": 638.55,
        "transcript": "Atam niicaurtellrianga ak'anek, ak'arrarnek tayim' ayaglua",
        "translation": "Look, I've started hearing since a long time ago, since quite a while ago"
    },
    "90": {
        "startTime": 638.55,
        "endTime": 643.26,
        "transcript": "Ak'mum nunam wiinga tangssuilkeḿa yugyalriim",
        "translation": "In those lands way over there that I do not see where there are a lot of people"
    },
    "91": {
        "startTime": 643.26,
        "endTime": 650.35,
        "transcript": "It started getting cold where they do not know cold; it started snowing where they do not know snow.",
        "translation": "It started getting cold where they do not know cold; it started snowing where they do not know snow."
    },
    "92": {
        "startTime": 650.35,
        "endTime": 655.27,
        "transcript": "Tua-i tamakut naucetaat assircanrirai.",
        "translation": "That is negatively affecting crops."
    },
    "93": {
        "startTime": 655.275,
        "endTime": 662.35,
        "transcript": "Cali-llu tayima piyagaat, tua-i cat cali piyugngalriit assircanrirai.",
        "translation": "It is also negatively affecting animal young, whatever wildlife there is."
    },
    "94": {
        "startTime": 662.35,
        "endTime": 667.93,
        "transcript": "Tayima akemkut wiinga tua-i tangssuilkeḿa yui",
        "translation": "Maybe the people of the lands that I do not see"
    },
    "95": {
        "startTime": 667.935,
        "endTime": 674.33,
        "transcript": "Nasperturluteng ellait, naugillerteng-wa tua-i nasperturluku.",
        "translation": "They are trying, trying [things] with their crops."
    },
    "96": {
        "startTime": 674.33,
        "endTime": 679.15,
        "transcript": "Umyuarteqaqama tamaańnguaqerlua",
        "translation": "When I think about it and pretend I'm there"
    },
    "97": {
        "startTime": 679.735,
        "endTime": 685.855,
        "transcript": "Unguvaseng tunulluku Alaska-m yuinek arcaqakingaitut.",
        "translation": "They will not turn their back on their lives and consider Alaskan people more important."
    },
    "98": {
        "startTime": 685.95,
        "endTime": 694.59,
        "transcript": "Cali-am waten qanrutqerciullruunga, mumignganrilngurnek-am qanrutqerciullruunga elisngalriamek:",
        "translation": "I was also told this, I was told this that was untranslated from a knowledgeable person:"
    },
    "99": {
        "startTime": 694.595,
        "endTime": 704.685,
        "transcript": "\"Naucetaalget-gguq naucetaamegteggun pimaarkaugut. Neqelget neqmegteggun pimaarkauluteng.\"",
        "translation": "\"Those with crops must [survive] with their crops. Those with food [from animals] must survive with their foor [from animals].\""
    },
    "100": {
        "startTime": 704.685,
        "endTime": 707.665,
        "transcript": "Tua-ll' tauna waten cali qanertuq:",
        "translation": "Then he also said this:"
    },
    "101": {
        "startTime": 708.17,
        "endTime": 714.43,
        "transcript": "\"Atam-gguq tamana mallguskan tamana erneruaq naliuciiqiaqan",
        "translation": "\"Watch, when the false day that wilts plants is nigh"
    },
    "102": {
        "startTime": 714.435,
        "endTime": 721.825,
        "transcript": "\"Atam-gguq yuut nepengniartut, tua-i ellalkangluteng. Camek atanqaanrirluteng.\"",
        "translation": "\"Watch, people will start fighting, acting crazy. They will no longer await anything.\""
    },
    "103": {
        "startTime": 721.825,
        "endTime": 730.675,
        "transcript": "Tua-i tang maa-i man'a cali waten ayuqellria tua-i maa-i nall'aringaarput qakemkuni ernerni watua maa-i.",
        "translation": "You see, we are corresponding to what is like this in these current days."
    },
    "104": {
        "startTime": 730.675,
        "endTime": 733.225,
        "transcript": "Ilateng tua-i cakenrirluki.",
        "translation": "They care nothing for their families anymore."
    },
    "105": {
        "startTime": 733.225,
        "endTime": 743.9,
        "transcript": "Aling cali mat'um nalliini nallunaipagta maurluat una qanqerteńgunripagta.",
        "translation": "Oh my, it is clear these days that their grandmother is not a teacher."
    },
    "106": {
        "startTime": 743.9,
        "endTime": 751.2,
        "transcript": "Cali-llu wangkurlumta tang apa'urlurluitni maani cailkami qanqerteńguvkenata.",
        "translation": "Also, you see, we poor grandfathers of their are also not teachers in random places here."
    },
    "107": {
        "startTime": 751.205,
        "endTime": 759.64,
        "transcript": "Tuarpiaq tang tua-i makut kingum yui, tuarpiaq tua-i tangvagluki anglanitekellriacetun ayuqluki.",
        "translation": "It truly seems that the chidlren of the next generation, it truly seems that we watch them with levity."
    },
    "108": {
        "startTime": 759.64,
        "endTime": 762.66,
        "transcript": "Inqautaunata mat'um nalliini.",
        "translation": "We have no [?affection] these days."
    },
    "109": {
        "startTime": 763.685,
        "endTime": 767.065,
        "transcript": "Tua-ll' umyuarteqaqama",
        "translation": "Then when I ponder"
    },
    "110": {
        "startTime": 767.49,
        "endTime": 773.7,
        "transcript": "Ella una piciqiaquni waten, uksuq man'a aturciqiange'rmiu",
        "translation": "When the world is on the verge of doing this, though it is on the verge of going through this winter"
    },
    "111": {
        "startTime": 773.7,
        "endTime": 778.46,
        "transcript": "Yun'i qanrusngaitai maa-i watua piqatarniluki.",
        "translation": "It will not tell it's people that it's going to do it now."
    },
    "112": {
        "startTime": 778.465,
        "endTime": 781.935,
        "transcript": "Cunaw' tang tamaa-i ava-i.",
        "translation": "It turns out it was all of that."
    },
    "113": {
        "startTime": 781.935,
        "endTime": 790.99,
        "transcript": "Ak'a tamalkuita pinrilnguunaki tamaa-i nasvallruamiu qanrulluki yun'i tamaaggun, tamaaggun piarkaurrluki.",
        "translation": "It had already shown its people through that, without leaving anything out, that it would do that."
    },
    "114": {
        "startTime": 790.99,
        "endTime": 795.95,
        "transcript": "Tua-ll' cali waten qanertuq tauna angukara'urluq:",
        "translation": "Then, that old man also said this:"
    },
    "115": {
        "startTime": 795.955,
        "endTime": 801.585,
        "transcript": "\"Atam-gguq tamana tamaa-i mallguskan piitnaq",
        "translation": "\"Watch, when that time of famine is nigh"
    },
    "116": {
        "startTime": 802.455,
        "endTime": 812.59,
        "transcript": "\"Waniwa-gguq ukuk ciiq, imarpinraq, atam-gguq kuignun neq'lirtuutengniartuq, neq'lirtuutengniartuk.\"",
        "translation": "These two, sheefish, Bering cisco, watch, they rivers will be filled with those two fish.\""
    },
    "117": {
        "startTime": 812.59,
        "endTime": 821.25,
        "transcript": "Tua-i-gguq waten yuk nangulluni-w' tua-i taukuk aipaagnek nerqerarkangqerrluni.",
        "translation": "He said that when a person runs out [of food] like this, one of those two will be his source of food."
    },
    "118": {
        "startTime": 821.255,
        "endTime": 829.905,
        "transcript": "Taukuk-gguq aipaagnek nerqaquciqsaaquq. Ilangcivkenani-gguq atam kemgiutniartuq, kemga iggniartuq.",
        "translation": "He said that he will eat a lot of one of those two. He said that despite that, he will grow skinny, his flesh falling off."
    },
    "119": {
        "startTime": 829.905,
        "endTime": 835.315,
        "transcript": "Neqek taukuk elluatuk assilriik uqulgulutek-llu",
        "translation": "Those to healthy and good fish that are also fatty"
    },
    "120": {
        "startTime": 835.485,
        "endTime": 840.915,
        "transcript": "\"Tua-i-gguq,\" qanertuq tauna, \"tua-i-gguq taulkuk neqek piitnam tamatum neqek.\"",
        "translation": "\"So,\" he said, \"so those two are the fish of famine.\""
    },
    "121": {
        "startTime": 840.915,
        "endTime": 848.745,
        "transcript": "Tua-i man'a avaullrunritaqa. Maa-i-w' tua-i umyuaqelguriamku tua-i ella una aaryagutaqa.",
        "translation": "I haven't forgotten this. Since it always comes to mind now, I've become wary of this world."
    },
    "122": {
        "startTime": 849.185,
        "endTime": 852.1,
        "transcript": "Tua-ll' cali waten qanellruut au͡gkut:",
        "translation": "Then, people back then also said this:"
    },
    "123": {
        "startTime": 852.1,
        "endTime": 860.75,
        "transcript": "\"Ukut-gguq waniwa taryaqviinkut, iqalluunkut, qakiiyaankut, taukut-gguq piirtuyuitut.\"",
        "translation": "\"These three, king salmon, chum salmon, silver salmon, those don't run out.\""
    },
    "124": {
        "startTime": 860.75,
        "endTime": 867.68,
        "transcript": "Taumek-gguq maa-i watuam nalliini kingumta yuinun waten au͡gkut ellaita qanruyutekellruat:",
        "translation": "That's why they gave this piece of traditional wisdom to the children of our descendants today like this:"
    },
    "125": {
        "startTime": 867.68,
        "endTime": 876.7,
        "transcript": "Taukut tua-i kuimallratni yuk piyugngakan qaategtevkenaku piyugngataciatun tamaaken tegutesqelluku.",
        "translation": "While those are swimming, if a person is able, he should not be lazy, but take as much as he can from them."
    },
    "126": {
        "startTime": 876.705,
        "endTime": 881.855,
        "transcript": "Inerquutekluku man'a uksuaq qagqesqevkenaku.",
        "translation": "They admonished against [?being unprepared for] fall."
    },
    "127": {
        "startTime": 881.855,
        "endTime": 891.61,
        "transcript": "Tamana-gguq atam aturarkaukuniu uksuq tamakut tamaa-i kinguqliktukai tamarmeng atam-gguq cataitniartut.",
        "translation": "They said that if it is going to have that kind of winter, all of the things that come after them will be gone."
    },
    "128": {
        "startTime": 891.61,
        "endTime": 896.51,
        "transcript": "Man'a maa-i umyuaqelguriaqa.",
        "translation": "This always comes to mind now."
    },
    "129": {
        "startTime": 896.515,
        "endTime": 902.83,
        "transcript": "Tua-ll' tamatum tamaa-i piitnam tuskateng",
        "translation": "Then when that famine comes upon them"
    },
    "130": {
        "startTime": 902.83,
        "endTime": 908.61,
        "transcript": "Cali au͡gna waten qanqautesciullruunga. Ak'arraurtuq.",
        "translation": "I was also told about that. It's been quite a while."
    },
    "131": {
        "startTime": 908.615,
        "endTime": 914.625,
        "transcript": "Cali umyuamnun agtuutellruuq waten qanqautesteḿa qanqautaanga",
        "translation": "It also moved my mind when the one who told me told this to me"
    },
    "132": {
        "startTime": 914.625,
        "endTime": 919.635,
        "transcript": "Elliin umyugaanun cali agtuutelliniuq waten qanerluni:",
        "translation": "It also moved his mind as he said this:"
    },
    "133": {
        "startTime": 919.635,
        "endTime": 923.71,
        "transcript": "Tauna-gguq tang qavangurtulria kuvyaluni.",
        "translation": "He said that he dreamt he was drift netting."
    },
    "134": {
        "startTime": 923.71,
        "endTime": 930.55,
        "transcript": "Tua-i waten aterrluni, qaill' tua-i kuvyilarceta, kuvyilarceci.",
        "translation": "He let the current carry him, however we drift net, you drift net."
    },
    "135": {
        "startTime": 930.555,
        "endTime": 934.365,
        "transcript": "Tua-i-ll' pinariami imegluni.",
        "translation": "Then when it was time, he rolled up his net."
    },
    "136": {
        "startTime": 934.365,
        "endTime": 943.455,
        "transcript": "Imginanrani neqa kan'a alairtuq, enret tamimek caquluteng amta-ll' pektanqeggluni.",
        "translation": "As he was rolling up his net, a fish appeared down there, entirely covered in bones yet was moving."
    },
    "137": {
        "startTime": 943.455,
        "endTime": 948.51,
        "transcript": "Tua-ll' alairami qanrutlinia tauna cangtaqesteńi",
        "translation": "Then when it appeared, it said to the one who caught it"
    },
    "138": {
        "startTime": 948.51,
        "endTime": 952.96,
        "transcript": "\"Uitaqaa. Malrugnek qanerkangqertua.\"",
        "translation": "\"Wait a second. I have two things to say.\""
    },
    "139": {
        "startTime": 952.96,
        "endTime": 956.9,
        "transcript": "Tua-ll' pillinia tauna cangtaqesteńi",
        "translation": "Then it said to the one who had caught it"
    },
    "140": {
        "startTime": 956.905,
        "endTime": 964.715,
        "transcript": "\"Tayima-gguq allrakut amllenrilnguut kinguatni piitnaq tut'eqatartuq",
        "translation": "\"After a few years, the time of famine is going to come"
    },
    "141": {
        "startTime": 964.715,
        "endTime": 968.185,
        "transcript": "\"Cali-llu tegelgem yua pekteqatarluni.\"",
        "translation": "\"And the spirit of theft is going to be active.\""
    },
    "142": {
        "startTime": 968.185,
        "endTime": 977.06,
        "transcript": "Atam au͡gkut wiinga tua-i angullrenka, anguyaaqekenka tua-i qanqaquuryaaqellriameng",
        "translation": "Look, though the people I was born to see had talked for a long time"
    },
    "143": {
        "startTime": 977.06,
        "endTime": 981.3,
        "transcript": "Nutaan atam wiinga tegelgem yuanek niitellrianga.",
        "translation": "You see, that was the first time I heard about the spirit of theft."
    },
    "144": {
        "startTime": 981.305,
        "endTime": 986.515,
        "transcript": "Tua-ll' taum tua-i qanqautestellma mat'um kinguani",
        "translation": "Then after that person spoke to me"
    },
    "145": {
        "startTime": 986.515,
        "endTime": 993.045,
        "transcript": "Tuar tang maa-i yuut allamiaqan tuar tang arcarikanilalriit. Tuar tang arcarikanilalriit.",
        "translation": "It seems that every year, people get worse. They seem to get worse."
    },
    "146": {
        "startTime": 993.045,
        "endTime": 998.4,
        "transcript": "Waten ilateng qinuuqluki. Teglegiluki, neqairluki tuaten.",
        "translation": "They do not share with their families. They steal from them, even take their food away."
    },
    "147": {
        "startTime": 998.4,
        "endTime": 1001.86,
        "transcript": "Yuut maa-i watua umyuarteqaqama",
        "translation": "When I ponder upon these people now"
    },
    "148": {
        "startTime": 1001.865,
        "endTime": 1008.075,
        "transcript": "Mayiteqkuneng uuggun aqsaqumegteggun qaillun pitaqatartat?",
        "translation": "If these they desire what was taken away from their stomachs, how far will they go?"
    },
    "149": {
        "startTime": 1008.075,
        "endTime": 1010.29,
        "transcript": "Ilateng-llu allurtelarciqait.",
        "translation": "They will also take from their families."
    },
    "150": {
        "startTime": 1010.29,
        "endTime": 1015.76,
        "transcript": "Wall'u tua-i yuut makut avanicetun ayuqenrirtut.",
        "translation": "Or, these people are not like long ago anymore."
    },
    "151": {
        "startTime": 1015.76,
        "endTime": 1019.21,
        "transcript": "Ilait uluryairulluteng, ilait-ll' alingnariluteng.",
        "translation": "Some have no more inhibitions, and some have gotten dangerous."
    },
    "152": {
        "startTime": 1019.21,
        "endTime": 1023.26,
        "transcript": "Ilii-llu neqrangqerrniluni tuqutauciquq-llu.",
        "translation": "And one of them will be killed because he has a little food."
    },
    "153": {
        "startTime": 1023.26,
        "endTime": 1027.17,
        "transcript": "Tua-i taklirivakartuq. Waten pitaaqa.",
        "translation": "It's getting to long. This is all I will say about it."
    },
    "154": {
        "startTime": 1028.03,
        "endTime": 1029.67,
        "transcript": "Quyana Chimigalrea.",
        "translation": "Thank you Chimigalrea."
    },
    "155": {
        "startTime": 1029.675,
        "endTime": 1034.835,
        "transcript": "Waniwa Asaacararmiut curukallratni suurkiullrulliniut Imangarmiut yurartai.",
        "translation": "Now, the dancers of Emmonak recorded a video when Mountain Village held a challenge feast."
    },
    "156": {
        "startTime": 1753.894,
        "endTime": 1756.464,
        "transcript": "Quyana. WIinga Qang'allugaugua.",
        "translation": "Thank you. I am Qang'allugaq."
    },
    "157": {
        "startTime": 1756.464,
        "endTime": 1760.614,
        "transcript": "Uumiku cali ilagarniararpekut Delta Review-aallemteńi.",
        "translation": "Join us next time for our Delta Review."
    }
};